<template>
  <svg viewBox="0 0 49 63" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M44.4389 32.9436C46.9337 29.4353 48.1031 25.5372 48.1031 21.1712C48.1031 15.4799 46.0761 10.6462 42.022 6.51421C37.9679 2.46014 33.0563 0.433105 27.365 0.433105H0L6.06378 10.8801H27.365C30.1716 10.8801 32.5885 11.8936 34.6155 13.9207C36.7205 15.9477 37.734 18.3646 37.734 21.1712C37.734 24.0559 36.7205 26.5507 34.6155 28.5777C32.5885 30.6047 30.1716 31.6183 27.365 31.6183L18.0874 31.5403L36.1748 62.8034H48.1031L35.3172 40.4281C38.9814 38.9468 42.022 36.452 44.4389 32.9436Z"
      fill="white"
    />
    <path d="M0 20.0322L25.4462 62.8035H0V20.0322Z" fill="#FF007C" />
  </svg>
</template>
